import React from 'react';
import { Collapsible } from '@shopify/polaris';

import './card-settings.scss';

export default function CardSettings({ children, number = 2, setOpenSetting, title, type, open }) {
  return (
    <div className='CartSettings'>
      <div className='card'>
        <div
          className={open ? 'card-header active' : 'card-header'}
          onClick={() => setOpenSetting(open !== type && type)}
        >
          <span className='number-card' data-num={number} />
          <span className='card-link'>{title}</span>
        </div>
        <Collapsible
          open={open === type}
          id={`basic-collapsible-sales-pop-type-${number}`}
          transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
          expandOnPrint
        >
          <div className='card-body relative'>{children}</div>
        </Collapsible>
      </div>
    </div>
  );
}
